import React, { useState, useEffect } from 'react';
import Loader from 'cccisd-loader';
import { getSupervisorCoaches } from '../../helpers/helpers';
import TfhCoachDashboard from '../TfhCoachDashboard';

const TfhSupervisorDashboard = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [allCoaches, setAllCoaches] = useState(null);
    const [selectedCoach, setSelectedCoach] = useState(null);

    useEffect(() => {
        async function getData() {
            const coaches = await getSupervisorCoaches();
            coaches.sort((a, b) => {
                if (a.firstName && b.firstName) {
                    return a.firstName.localeCompare(b.firstName);
                }
                if (a.lastName && b.lastName) {
                    return a.lastName.localeCompare(b.lastName);
                }
                return a.username.localeCompare(b.username);
            });
            setAllCoaches(coaches);
            if (coaches.length > 0) {
                setSelectedCoach(coaches[0].pawnId);
            }
            setIsLoading(false);
        }

        getData();
    }, []);

    if (isLoading || !allCoaches) {
        return <Loader loading />;
    }

    if (allCoaches.length === 0) {
        return (
            <div className="alert alert-info">
                <p className="mb-0">
                    You have no Together for Health Coaches under your supervision. This page is intentionally blank.
                </p>
            </div>
        );
    }

    return (
        <div>
            <div className="mb-5">
                <label htmlFor="coach" className="form-label">
                    Coach:
                </label>

                <select
                    style={{ width: 'fit-content' }}
                    className="form-select"
                    aria-label="Coach"
                    id="coach"
                    name="coach"
                    onChange={event => {
                        setSelectedCoach(parseInt(event.target.value, 10));
                    }}
                    value={selectedCoach}
                >
                    {allCoaches.map(coach => (
                        <option key={coach.pawnId} value={coach.pawnId}>
                            {coach.firstName} {coach.lastName} ({coach.username})
                        </option>
                    ))}
                </select>
            </div>

            <TfhCoachDashboard coachPawnId={selectedCoach} />
        </div>
    );
};

export default TfhSupervisorDashboard;
